import { useState } from 'react';

import { clockIcon, menuIcon, closeIcon } from '../../utils/icons';
import { getButtonContent } from '../../utils/functions';

const SteppedContent = ({ attributes, useStep, children }) => {
	const { nav = {}, data, title, menu = {}, buttons = {}, isDoneBtn, doneBtnLink } = attributes;
	const { display = true } = nav;
	const { theme = 'numberCount' } = menu;
	const { back = { content: 'text', text: 'Back', colors: { color: '#1a73e8', bg: '#fff' } }, next = { content: 'text', text: 'Next', colors: { color: '#fff', bg: '#1a73e8' } }, done = { text: 'Done', linkTab: '_self', colors: { color: '#fff', bg: '#1e8e3e' } } } = buttons;

	const { step, onSetStep, minuteText, secondText } = useStep;

	const [mobileMenuActive, setMobileMenuActive] = useState('');

	const remainingText = minuteText ? `${minuteText} and ${secondText}` : secondText;

	return <div className='stpContent'>
		{display && <nav className='stpNav'>
			{mobileMenuActive ? <a className='menuClose' title='Close Menu' onClick={e => {
				e.preventDefault();
				setMobileMenuActive('');
			}}>{closeIcon}</a> : <a className='menuOpen' title='Open Menu' onClick={e => {
				e.preventDefault();
				setMobileMenuActive('active');
			}}>{menuIcon}</a>}

			<h2>{title}</h2>

			<div className='remainingTime'>
				{clockIcon}
				{remainingText}
			</div>
		</nav>}

		<div className='stpSection' onClick={() => setMobileMenuActive('')}>
			<nav className={`stpMenu ${mobileMenuActive}`}>
				<ol className={theme}>
					{data.length ? data.map((d) => <li key={d.step} className={d.step === step ? 'running' : d.step < step ? 'complete' : ''} onClick={() => onSetStep(d.step)}>
						<a>
							<span>{d.title}</span>
						</a>
					</li>) : <li><a>Please add a step!</a></li>}
				</ol>
			</nav>

			<div className='stpStepsWrapper'>
				{children}

				<div className='sptStepsControls'>
					<div className='controlsInner'>
						{1 < step && <button className={`docControlBtn prevBtn ${back.content}`} title='Previous step' onClick={() => onSetStep(step - 1)}>
							{getButtonContent(back, data[step - 2]?.title)}
						</button>}

						{step === data.length && isDoneBtn && <a href={doneBtnLink} target={done.linkTab} className='docControlBtn doneBtn' title='Document Complete'>{done.text}</a>}

						{step < data.length && <button className={`docControlBtn nextBtn ${next.content}`} title='Next step' onClick={() => onSetStep(step + 1)}>
							{getButtonContent(next, data[step]?.title)}
						</button>}
					</div>
				</div>
			</div> {/* Steps Wrapper */}
		</div>
	</div>
}
export default SteppedContent;